import React from 'react';
import { listLeverage } from '../../actions/leverageActions';
import { getForms } from '../../actions/formActions';
import { useSelector, useDispatch } from 'react-redux';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';

const ManageLeverage = (props) => {
    const searchBoxKey = "leverage_search_form";
    const listFormKey = "leverage_list_form";
    const dispatch = useDispatch();
    const leverageState = useSelector((state) => state.leverage);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { listing = {} } = leverageState;

    const listApi = (data) => {
        return dispatch(listLeverage(data, listFormKey));
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={listing}
            />
        </div>
    );
}

export default ManageLeverage;
